import { z } from 'zod';
/**
 * Per `voice-experiment-framework` change (voice-loop iter 1) —
 * operator-facing kill-switch table for the smoothness experiments.
 *
 * One row per experiment. Iterations of the voice-loop create rows
 * on first deploy; the admin UI page lets the operator flip each
 * `enabled` to disable a misbehaving experiment without redeploying.
 *
 * `default-on` per the plan — missing rows are treated as enabled so
 * a new experiment turns on the moment it ships; the operator
 * explicitly disables it if it misbehaves.
 */
export const VoiceExperimentFlagSchema = z.object({
    /** Stable key — kebab-case, e.g. 'asr_auto_restart'. PK in DDB. */
    flagKey: z.string().min(1).max(64),
    enabled: z.boolean(),
    /** Short human label, shown in the admin UI toggle list. */
    label: z.string().max(120),
    /** Longer description (what the experiment does + why operator
     *  might disable it). Markdown is fine; UI renders plain text. */
    description: z.string().max(600).default(''),
    updatedAt: z.string().datetime(),
    updatedBy: z.string().default(''),
});
